import { currencyFormatter } from '@dnhb/formatters';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import analytics from 'shared/utility/analytics';
import { LabelText, Heading, Info } from 'shared/components';
import { RadioSwitch, SelectInput } from 'shared/inputs';
import { InputsContainer } from 'shared/containers';
import { SYNC, sync } from 'shared/wizard/actions';

const WizardLanding = () => {
  const {
    input: { mortgage_provider_id, mortgage_provider_label, has_nhg },
    output: { errors },
    settings: { mortgage_providers, currentNhgMaxLoan },
  } = useSelector(state => state);
  const dispatch = useDispatch();
  const syncAction = sync(dispatch);

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false });
    analytics.send('Navigeer', 'Voorpagina');
  }, []);

  const labelOptions = mortgage_providers.find(provider => provider.value === mortgage_provider_id)?.labels || [];

  return (
    <>
      <Heading>Je hypotheek</Heading>
      <InputsContainer>
        <LabelText>Je hypotheekverstrekker</LabelText>
        <SelectInput
          placeholder="Kies een verstrekker"
          options={mortgage_providers}
          value={mortgage_provider_id}
          onChange={option => {
            syncAction('mortgage_provider_id', option.value);
            if (option.labels.length === 2) syncAction('mortgage_provider_label', option.labels[1].value);
            else syncAction('mortgage_provider_label', null);
          }}
          noOptionsMessage={() => 'Geen resultaten'}
          errors={errors.mortgage_provider_id}
          isSearchable
        />
        {labelOptions.length > 2 && (
          <>
            <LabelText>Je label</LabelText>
            <SelectInput
              placeholder="Selecteer een label"
              options={labelOptions}
              value={mortgage_provider_label}
              onChange={option => syncAction('mortgage_provider_label', option.value)}
              noOptionsMessage={() => 'Geen verstrekker geselecteerd'}
              errors={errors.mortgage_provider_label}
              isSearchable
            />
          </>
        )}
        <LabelText>
          Heb je een hypotheek met Nationale Hypotheek Garantie (NHG)
          <Info title="Nationale Hypotheek Garantie (NHG)">
            De Nationale Hypotheek Garantie (NHG) is een borgstelling op hypotheken tot{' '}
            {currencyFormatter(currentNhgMaxLoan)} (in {new Date().getFullYear()}). Sluit je een NHG-hypotheek af, dan
            leen je veiliger. Als je jouw huis voor minder verkoopt dan nodig is om jouw hypotheek af te lossen, dan kan
            NHG onder bepaalde voorwaarden borg voor jou staan en in sommige gevallen een restschuld kwijtschelden. Voor
            meer informatie: https://www.nhg.nl/Consument/Wat-is-NHG
          </Info>
        </LabelText>
        <RadioSwitch name="nhg" onChangeHandler={syncAction('has_nhg')} checked={has_nhg} errors={errors.has_nhg} />
      </InputsContainer>
    </>
  );
};

export default WizardLanding;
